import React from "react";
import { Form } from "react-bootstrap";
import {treatments_list} from '../../../lists/treatments-list'
import { useForm } from "react-hook-form";

export default function TreatmentForm(props) {
    let sortTreatment = props.sortTreatment;
    const {register} = useForm();


    const handleChange = (event) => {
      console.log(event.target.value);
      let treatment = JSON.parse(event.target.value).label;
      if(!treatment){
        treatment = 'All'
      }
      console.log(treatment)
      sortTreatment(treatment);
    };

      return (
        <div className=''>
            <Form.Group controlId="services">
            <Form.Label>Service</Form.Label>
                <Form.Control onChange={(e) => handleChange(e)} as="select"  name="services" ref={register ({required:true})} custom>
                  <option value={`{"value": "All", "label":"All"}`}>All</option>
                    {treatments_list.map((treatment, idx) => (
                        <option key ={idx} value={JSON.stringify(treatment)}>{treatment.label}</option>
                    ))}
                </Form.Control>
            </Form.Group>
        </div>
      );

  }
  
